<sc-flex vertical stretchContent fitHeight>
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.select-trailer-swap-target"></sc-dictionary-label>
  </sc-title>
  <sc-flex-fitting-content vertical>
    <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent [hideFilter]="true"
      (selectionChanged)="onSelectionChanged($event)">
    </sc-tmc-table>
  </sc-flex-fitting-content>
</sc-flex>
